import React, { useEffect, useState } from 'react';
import {Navigate} from 'react-router-dom';
import { useSelector } from "react-redux";
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import CircularLoading from "../components/CircularLoading";

function matchUser(permit, usertype){
    let permitions = permit? permit.split(',') : [];
    let permitted = false;
    for(let i=0;i<permitions.length;i++){
        permitted = usertype === permitions[i]?true:false
        if(permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit, children, menuPos }) {
    const auth = useSelector(state => state.auth);
    const [checkedAuth,setCheckedAuth] = useState(false);

    useEffect(()=>{
        if(auth.profile && auth.profile.uid){
            setCheckedAuth(true);
        }
        if(auth.error && auth.error.msg && !auth.profile){
            setCheckedAuth(true);
        }
    },[auth.profile,auth.error])

    const isPermitted = () => {
        if (!auth.profile) return false;
        if (auth.profile.usertype === 'subadmin') {
            // Explicitly permitted for subadmin?
            if (matchUser(permit, 'subadmin')) return true;
            
            // Does it permit admin, and does this subadmin have the specific menuPos?
            if (matchUser(permit, 'admin')) {
                if (menuPos !== undefined && auth.profile.menuOptions && auth.profile.menuOptions.some(opt => String(opt) === String(menuPos))) {
                    return true;
                }
            }
            return false;
        } else {
            return matchUser(permit, auth.profile.usertype);
        }
    };

    return(
        checkedAuth?
            auth.profile && auth.profile.uid?
            isPermitted() ? <ResponsiveDrawer>{children}</ResponsiveDrawer>:<Navigate to="/" />
            :<Navigate to="/login" /> 
        :<CircularLoading/>
    )
}

export default ProtectedRoute;